import React, { useContext, useState, useEffect, useRef } from 'react';
import { colors, TextField } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import {
    Button,
    Dropdown,
    Form,
    Checkbox,
    Divider,

} from "semantic-ui-react";

import ModalPortal from '../../generic/ModalPortal';
import { AppContext } from '../../../AppContext';
import { enrollStudent, getDataForExistingParent } from "../../../apiclients/AcademyClient";
import { getBatches } from "../../../apiclients/AcademyClient";
import { DAYS_OF_WEEK } from '../../../utils/constants';
import { getNumberOfDays } from '../../../utils/helperFunctions';
import Payment from "../../dashboard/Payment";
import DatesSelection from '../../common/DatesSelection';
import moment from 'moment';

const EnrollStudent = (props) => {
    const { showModal, setReload, setMessage, isLoading, selectedSport, isRenewal, renewalDetails, leadDetails, trialId } = props;
    const context = useContext(AppContext);
    const facilityId = context.selectedFacility;
    const arenaId = context.selectedArena.arenaId;
    const arenaData = context.arenaData[arenaId];
    const sportId = selectedSport.key;

    // console.log('the arena data is ', arenaData);
    const [mobile, setMobile] = useState();
    const [parentName, setParentName] = useState();
    // const [studentName, setStudentName] = useState();
    const [studentFirstName, setStudentFirstName] = useState();
    const [studentLastName, setStudentLastName] = useState();
    const [email, setEmail] = useState();
    const [emailValid, setEmailValid] = useState(true);
    const [typingTimeout, setTypingTimeout] = useState(null);
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [batchName, setBatchName] = useState();
    const [selectedBatch, setSelectedBatch] = useState();
    const [selectedBatchData, setSelectedBatchData] = useState();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedendDate, setSelectedEndDate] = useState(null);
    const [selectedendData, setSelectedEndData] = useState(null);

    const [fees, setFees] = useState();
    const [days, setDays] = useState([]);
    const [remarks, setRemarks] = useState();
    const [listOfBatches, setListOfBatches] = useState([]);
    const [listofEndDates, setListOfEndDates] = useState([]);
    const [numberOfClasses, setNumberOfClasses] = useState();
    const [showNumberOfClasses, setShowNumberOfClasses] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [disableDates, setDisableDates] = useState(false);
    const [discount, setDiscount] = useState(0);
    const [totalAmount, setTotalAmount] = useState();
    const [netAmount, setNetAmount] = useState();
    const [paymentArray, setPaymentArray] = useState([]);
    const [totalPayment, setTotalPayment] = useState();
    const [newParent, setNewParent] = useState(true);
    const [showMultipleStudents, setShowMultipleStudents] = useState(false);
    const [listOfStudents, setListOfStudents] = useState([]);
    const [isOtherSelected, setIsOtherSelected] = useState(false);
    const [disableStudentDetails, setDisableStudentDetails] = useState(false);
    const [ddstudentName, setDdStudentName] = useState();
    const [registrationFees, setRegistrationFees] = useState(false);
    const [disableParentNameAndEmail, setDisableParentNameAndEmail] = useState(false);
    const [openDatePopUp, setOpenDatePopUp] = useState("")
    const dateInputRef = useRef();
    const isSubmitAllowed = mobile && parentName && studentFirstName && studentLastName
        && email && emailValid && dateOfBirth != null &&
        startDate != null && fees
        && selectedBatch != null
        && discount != null && netAmount != null && totalPayment != null && totalPayment <= netAmount;

    const showBatchesOptions = mobile && parentName && studentFirstName && studentLastName
        && email && dateOfBirth != null;

    useEffect(() => {
        if (isRenewal) {
            setMobile(renewalDetails.mobile);
            setParentName(renewalDetails.parentName);
            // setStudentName(renewalDetails.studentName);
            setStudentFirstName(renewalDetails.studentName.split(' ')[0]);
            setStudentLastName(renewalDetails.studentName.split(' ')[1]);
            setEmail(renewalDetails.email);
            setDateOfBirth(new Date(renewalDetails.dateOfBirth.seconds * 1000));
            setDisableParentNameAndEmail(true);
            setDisableStudentDetails(true);
        }
        if (leadDetails) {
            setMobile(leadDetails.mobile);
            setParentName(leadDetails.parentName);
            // setStudentName(leadDetails.studentName);
            setStudentFirstName(leadDetails.studentName.split(' ')[0]);
            setStudentLastName(leadDetails.studentName.split(' ')[1]);
            setEmail(leadDetails.email);
            setDateOfBirth(new Date(leadDetails.dateOfBirth.seconds * 1000));
            setDisableParentNameAndEmail(true);
            setDisableStudentDetails(true);
        }
        getBatches(
            facilityId,
            arenaId,
            sportId,
        ).then((response) => {
            let data = response.data;
            // console.log("esponse.data", response.data)
            data = data.map((x, i) => {
                return {
                    key: i,
                    value: x.createdAt,
                    text: x.batchName,
                    fees: x.fees,
                    duration: x.duration,
                    registrationFees: x.registrationFees,
                    days: x.days
                }
            });

            setListOfBatches(data);
        })
    }, []);



    const changeBatch = (event, obj) => {
        const { value, options } = obj
        const batchData = options.filter(x => x.value.seconds === value.seconds)[0]
        setSelectedEndData(null)
        setSelectedBatchData(batchData)
        setBatchName(batchData.text)
        setSelectedBatch(value);
        setStartDate(null)
        setListOfEndDates([])
    };
    const selectEndDate = (event, obj) => {

        const { value, options } = obj
        // console.log("value", obj)

        const endDateData = options.filter(x => moment(x.value).isSame(moment(value), 'day'))[0]
        // console.log("endDateData",endDateData)
        if (endDateData.text === "Other") {
            console.log("inside other ")
            console.log("endDateData", endDateData)
            setSelectedEndData(endDateData)
            setEndDate(null)
            return
        }
        if (endDateData) {
            // console.log("endDateData", endDateData)
            setFees(Number(endDateData.fees));
            setEndDate(endDateData.value)
            setSelectedEndData(endDateData)
            if (!isRenewal) {
                setRegistrationFees(Number(selectedBatchData.registrationFees));
                setNetAmount(Number(endDateData.fees) + Number(selectedBatchData.registrationFees));
                setTotalAmount(Number(endDateData.fees) + Number(selectedBatchData.registrationFees));
            } else {
                setRegistrationFees(0);
                setNetAmount(Number(endDateData.fees));
                setTotalAmount(Number(endDateData.fees));
            }
        }
    };

    const addDiscount = (value) => {
        setDiscount(value);
        let total = Number(fees) + Number(registrationFees) - Number(value);
        //  let total = Math.round((fees + registrationFees-value));
        setNetAmount(total);
    }

    const updatePaymentArray = (updatedArray) => {
        const amountPaid = updatedArray.reduce((a, b) => a + Number(b.amount), 0);
        setTotalPayment(amountPaid);
        setPaymentArray(updatedArray);

    };

    const changeEndDate = (value) => {


        const enddate = moment(value);
        setEndDate(enddate)
        const duration = selectedBatchData.duration
        let totalDays = 0
       
        if (duration == 1) {
            totalDays = totalDays + moment(value).daysInMonth()
            const diffInDays = enddate.diff(startDate, 'days');
            const totalFees = ((Number(selectedBatchData.fees) / Number(totalDays)) * Number(diffInDays + 1)).toFixed(2)
            setFees(Number(totalFees))
          
            if (!isRenewal) {
                setRegistrationFees(Number(selectedBatchData.registrationFees));
                setNetAmount(Number(totalFees) + Number(selectedBatchData.registrationFees));
                setTotalAmount(Number(totalFees) + Number(selectedBatchData.registrationFees));
            } else {
                setRegistrationFees(0);
                setNetAmount(Number(totalFees));
                setTotalAmount(Number(totalFees));
            }
           
        }



    }


    const changeStartDate = (value) => {

        // setOpenDatePopUp("")
        // if(openDatePopUp==="end_date"){

        //     return
        // }
        const enddate = moment(value).add(parseInt(selectedBatchData.duration), 'month').subtract(1, 'day');
        const duration = selectedBatchData.duration
        let totalDays = 0
        let optionArray = []
        if (duration == 1) {
            totalDays = totalDays + moment(value).daysInMonth()
            // console.log("totalDays", totalDays) 
            const curentDayinMonth = moment(value).date()
            // console.log("curentDayinMonth", curentDayinMonth)
            const remainingDays = totalDays - curentDayinMonth + 1;
            // console.log("remainingDays", remainingDays)
            const endThisMonthFees = ((Number(selectedBatchData.fees) / Number(totalDays)) * Number(remainingDays)).toFixed(2)
            // console.log("endThisMonthFees", endThisMonthFees)
            const endThisMonthDate = moment(value).endOf('month')
            // console.log("endThisMonthDate", endThisMonthDate)
            let newObj = {
                key: 0,
                value: endThisMonthDate,
                fees: Number(endThisMonthFees),
                text: endThisMonthDate.format('DD MMM YYYY'),
            }
            optionArray.push(newObj)
        } else {
            setSelectedEndData({
                key: 1,
                value: enddate,
                fees: Number(selectedBatchData.fees),
                text: enddate.format('DD MMM YYYY'),
            })
        }
        optionArray.push({
            key: 1,
            value: moment(value).add(parseInt(selectedBatchData.duration), 'month').subtract(1, 'day'),
            fees: Number(selectedBatchData.fees),
            text: moment(value).add(parseInt(selectedBatchData.duration), 'month').subtract(1, 'day').format('DD MMM YYYY'),
        })
        if (duration == 1) {
            let newObj = {
                key: 2,
                value: moment("14 07 1998", "DD MM YYYY"),
                fees: 0,
                text: "Other",
            }
            optionArray.push(newObj)
        }
        setListOfEndDates(optionArray)
        setStartDate(value)
        setSelectedEndData(null)
    }
    // console.log("listofEndDates", listofEndDates)
    const fetchParentData = (mobiles) => {
        if (mobiles && mobiles.length === 10) {

            setMobile(mobiles);
            getDataForExistingParent(facilityId, arenaId, sportId, mobiles)
                .then((response) => {
                    console.log('the response is ', response.data);
                    let data = response.data;
                    data.push({ key: data.length, value: 'Others', text: 'Others' })
                    if (response.data.length > 1) {
                        console.log('the response is ', response.data);
                        setListOfStudents(data);
                        setNewParent(false);
                        setShowMultipleStudents(true);
                    }
                });
        }
    }

    const changeStudent = (event, { value, options }) => {
        if (value === 'Others') {
            setIsOtherSelected(true);
            const parentName = options[0].parentName;
            const email = options[0].email;
            setDdStudentName(value);
            // setStudentName(null);
            setStudentFirstName(null);
            setStudentLastName(null);
            setParentName(parentName);
            setEmail(email)
            setDateOfBirth(null);
            setDisableParentNameAndEmail(true);
            setDisableStudentDetails(false);
        } else {
            const studentName = options.filter(x => x.value === value)[0].text;
            const email = options.filter(x => x.value === value)[0].email;
            const parentName = options.filter(x => x.value === value)[0].parentName;
            const dob = new Date(options.filter(x => x.value === value)[0].dateOfBirth.seconds * 1000);
            setDdStudentName(value);
            // setStudentName(studentName);
            setStudentFirstName(studentName.split(' ')[0]);
            setStudentLastName(studentName.split(' ')[studentName.split(' ').length - 1]);
            setEmail(email);
            setParentName(parentName);
            setDateOfBirth(dob);
            setIsOtherSelected(false);
            setDisableParentNameAndEmail(true);
            setDisableStudentDetails(true);
        }

    };
    const validateEmail = (email) => {
        // Simple regex for email validation
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        setEmailValid(null); // Reset validation while typing

        if (typingTimeout) clearTimeout(typingTimeout);

        setTypingTimeout(
            setTimeout(() => {
                setEmailValid(validateEmail(value));
            }, 500) // 500ms after user stops typing
        );
    };

    const modalContent = (
        <div>
            <Form>

                <Form.Group widths='equal'>
                    <Form.Field  >
                        <label>Mobile Number</label>
                        <input
                            style={{ marginRight: "6px" }}
                            disabled={disableStudentDetails}
                            type='number'
                            value={mobile}
                            pattern='[0-9]{10}$*'
                            placeholder='9911XXXXXX'
                            // onFocus={}
                            onChange={(evt) => fetchParentData(evt.target.value)}

                        />
                    </Form.Field>
                    {showMultipleStudents ?
                        <Form.Field  >

                            <label>Select Students</label>
                            <Dropdown
                                onChange={changeStudent}
                                placeholder='Select...'
                                openOnFocus
                                selection
                                value={ddstudentName}
                                options={listOfStudents}
                                style={{ marginRight: "30px" }}
                            />
                        </Form.Field>
                        :
                        <>
                            <Form.Field  >
                                <label>Student First Name</label>
                                <input
                                    style={{ marginRight: "6px" }}
                                    type='text'
                                    value={studentFirstName}
                                    disabled={disableStudentDetails}
                                    placeholder='Shaurya'
                                    onChange={(evt) => setStudentFirstName(evt.target.value)}

                                />
                            </Form.Field>
                            <Form.Field  >
                                <label>Student Last Name</label>
                                <input
                                    style={{ marginRight: "6px" }}
                                    type='text'
                                    value={studentLastName}
                                    placeholder='Jain'
                                    onChange={(evt) => setStudentLastName(evt.target.value)}

                                />
                            </Form.Field>
                        </>

                    }
                    {isOtherSelected ? <>
                        <Form.Field  >
                            <label>Student First Name</label>
                            <input
                                style={{ marginRight: "6px" }}
                                type='text'
                                value={studentFirstName}
                                disabled={disableStudentDetails}
                                placeholder='Shaurya'
                                onChange={(evt) => setStudentFirstName(evt.target.value)}

                            />
                        </Form.Field>
                        <Form.Field  >
                            <label>Student Last Name</label>
                            <input
                                style={{ marginRight: "6px" }}
                                type='text'
                                value={studentLastName}
                                disabled={disableStudentDetails}
                                placeholder='Jain'
                                onChange={(evt) => setStudentLastName(evt.target.value)}

                            />

                        </Form.Field>
                    </> : null}


                </Form.Group>
                <Form.Group widths='equal'>
                    <Form.Field  >
                        <label>Parent Name</label>
                        <input
                            style={{ marginRight: "6px" }}
                            type='text'
                            value={parentName}
                            placeholder='Vishal Jain'
                            onChange={(evt) => setParentName(evt.target.value)}
                            disabled={disableParentNameAndEmail}

                        />
                    </Form.Field>

                    <Form.Field  >
                        <label>Email</label>
                        <input
                            style={{ marginRight: "6px" }}
                            type='email'
                            value={email}
                            placeholder='shaurya@gmail.com'
                            onChange={(evt) => handleEmailChange(evt)}

                            disabled={disableParentNameAndEmail}
                        />
                        {!emailValid && <span style={{ color: 'red' }}>Invalid email</span>}
                    </Form.Field>
                    <Form.Field  >

                        <label>Date of Birth</label>
                        <DatePicker

                            autoOk
                            disableFuture
                            disabled={disableStudentDetails}
                            variant='inline'
                            value={dateOfBirth}
                            placeholder='Select Date...'
                            onChange={setDateOfBirth}
                            format='DD MMM yyyy'
                        />

                    </Form.Field>


                </Form.Group>

                {showBatchesOptions ?
                    <>
                        <Divider horizontal>
                            <span style={{ color: colors.blue["400"] }}>Batch Details</span>
                        </Divider>
                        <Form.Group widths='equal'>
                            <Form.Field  >

                                <label>Batches</label>
                                <Dropdown
                                    onChange={changeBatch}
                                    placeholder='Select...'
                                    openOnFocus
                                    selection
                                    value={selectedBatch}
                                    options={listOfBatches}
                                    style={{ marginRight: "30px" }}
                                />
                            </Form.Field>
                            <Form.Field  >

                                <label> Start Date</label>

                                <DatePicker

                                    autoOk
                                    minDate={moment().subtract(15, 'days').toDate()}
                                    // disabled={disableStudentDetails}
                                    // open={openDatePopUp==="start_date" }
                                    variant='inline'
                                    value={startDate}
                                    placeholder='Select Date...'
                                    onChange={changeStartDate}
                                    format='DD MMM yyyy'

                                />


                            </Form.Field>
                            <Form.Field  >

                                <label>End Date</label>
                                <Dropdown
                                    onChange={selectEndDate}
                                    placeholder='Select...'
                                    openOnFocus
                                    selection
                                    value={selectedendData && selectedendData.value ? selectedendData.value : null}
                                    options={listofEndDates}
                                    style={{ marginRight: "30px" }}
                                />

                            </Form.Field>
                            {selectedendData && selectedendData.text === "Other" && (
                                <Form.Field  >
                                    <label> Other End Date</label>
                                    <DatePicker
                                        autoOk
                                        maxDate={moment().add(90, 'days').toDate()}
                                        minDate={startDate}
                                        variant='inline'
                                        value={endDate}
                                        placeholder='Select Date...'
                                        onChange={changeEndDate}
                                        format='DD MMM yyyy'
                                    />

                                </Form.Field>
                            )}

                        </Form.Group>
                        {endDate && (
                            <Form.Group widths='equal'>

                                <Form.Field  >

                                    <label>Fees</label>
                                    <input
                                        style={{ marginRight: "6px" }}
                                        disabled
                                        type='number'
                                        value={fees}
                                        placeholder='12'
                                        onChange={(evt) => setFees(evt.target.value)}

                                    />
                                </Form.Field>
                                <Form.Field  >

                                    <label>Registration Fees</label>
                                    <input
                                        style={{ marginRight: "6px" }}
                                        disabled
                                        type='number'
                                        value={registrationFees}
                                        placeholder='12'
                                        onChange={(evt) => setRegistrationFees(evt.target.value)}

                                    />
                                </Form.Field>
                            </Form.Group>
                        )}

                        {endDate ?
                            <Form.Group widths='equal'>

                                <Form.Field  >
                                    <label>Enrollment Discount Amount</label>
                                    <input
                                        style={{ marginRight: "6px" }}
                                        type='text'
                                        // pattern='^\d*\.?\d{0,4}$'
                                        value={discount}
                                        placeholder='enter discount in number'
                                        onInput={(evt) => addDiscount(evt.target.value)}
                                    />
                                </Form.Field  >
                                <Form.Field  >
                                    <label>Total Enrollment amount</label>
                                    <input
                                        style={{ marginRight: "6px" }}
                                        disabled
                                        type='number'
                                        value={netAmount.toFixed(2)}
                                        placeholder='0 % Applicable on only Fees'
                                        onChange={() => { }}
                                    />
                                </Form.Field  >

                                <Form.Field  >

                                    <label>Remarks</label>
                                    <input
                                        style={{ marginRight: "6px" }}
                                        type='text'
                                        value={remarks}
                                        placeholder='Additional information'
                                        onChange={(evt) => setRemarks(evt.target.value)}

                                    />
                                </Form.Field>
                            </Form.Group> : null}
                        {/* {showErrorMessage ?
                            <div>
                                <span style={{ color: "red" }}>Please select the Start/End date and days first and then select the batch.</span>
                            </div>
                            : null} */}
                        {endDate ? <>

                            <Divider horizontal>
                                <span style={{ color: colors.blue["400"] }}>Payment</span>
                            </Divider>
                            <div style={{ marginBottom: "7px", fontWeight: "bold" }}>
                                Total Amount - Rs. {netAmount.toFixed(2)}/-
                            </div>
                            <div style={{ marginBottom: "7px", fontWeight: "bold" }}>
                                Payment Breakup
                            </div>
                            <Payment
                                paymentArray={paymentArray}
                                setPaymentArray={updatePaymentArray}
                            />
                            <div style={{ paddingTop: "10px" }}>
                                <span style={{ fontWeight: "bold" }}>Total Payment: Rs. </span>
                                <span>{totalPayment}/-</span>
                            </div>
                        </>
                            : null}
                    </>
                    : null}
            </Form>
        </div>
    );

    const renderAction = () => {
        return (
            <React.Fragment>
                <Button onClick={() => showModal(false)} className='ui button'>Cancel</Button>

                <Button primary disabled={!isSubmitAllowed} onClick={addStudent}>  Submit</Button>
            </React.Fragment>
        );
    };

    const addStudent = () => {
        showModal(false);
        isLoading(true);
        const completeStudentName = studentFirstName + " " + studentLastName;
        let body = {
            facilityId,
            arenaId,
            sportId,
            batchName,
            mobile,
            parentName,
            studentName: completeStudentName,
            email,
            fees,
            days: selectedBatchData.days,
            dateOfBirth,
            startDate,
            endDate:selectedendData && selectedendData.text === "Other" ? endDate : selectedendData.value,
            discount,
            totalAmount,
            netAmount,
            paymentInfo: paymentArray,
            //  numberOfClasses, 
            newParent,
            remarks,
            registrationFees,
            createdBy: {
                userName: context.user.userName,
                userId: context.user.userId,
            },
            isRenewal, trialId,
            arenaData
        };
        console.log("body", body)
        const postBody = isRenewal ? { ...body, oldEnrollmentId: renewalDetails.enrollmentId } : body;

        enrollStudent(
            postBody
        ).then((response) => {
            if (response.status === 200 || response.status === 201) {
                setMessage({
                    header: "Student Added",
                    message: "Student has been added successfully.",
                    color: "green",
                });
            } else {
                setMessage({
                    header: "Error!",
                    message: response.data.error.message,
                    color: "red",
                });
            }
            setReload(true);
        }).catch((error) => {

            setMessage({
                header: "Error!",
                message: error.message,
                color: "red",
            });
            setReload(true);
        });


    }
    return (
        <>
            <ModalPortal
                title='Add Student'
                content={modalContent}
                action={renderAction()}
                onDismiss={() => showModal(false)}
            />

        </>

    );


}
export default EnrollStudent;